// Types
import {
  GetCampaignOffers_getCampaignOffers_entities_deliverables_items,
  GetCampaignOffers_getCampaignOffers_entities_deliverables_items_CBDeliverableCopy_task,
  GetCampaignOffers_getCampaignOffers_entities_deliverables_items_CBDeliverableFileItem_task,
  GetCampaignOffers_getCampaignOffers_entities_deliverablesV2_items_CbDeliverableFilesItemV2,
} from 'api/campaignV2/types/GetCampaignOffers';
import { CampaignMediaType, CampaignTaskType } from 'api/graphql-global-types';

export const getMediaTypeText = (mediaType?: CampaignMediaType): string => {
  if (!mediaType) return '';

  switch (mediaType) {
    case CampaignMediaType.IMAGE:
      return 'Image';
    case CampaignMediaType.VIDEO:
      return 'Video';
    default:
      return 'Unknown';
  }
};

// Generic function that works with any task type
export const getTaskTypeText = (
  task: {
    type: CampaignTaskType;
    __typename?: string;
    mediaType?: CampaignMediaType | null;
  } | null
): string => {
  if (!task) return '';

  switch (task.type) {
    case CampaignTaskType.IG_LIVE:
      return 'Instagram Live';
    case CampaignTaskType.IG_POST:
      return 'Instagram Post';
    case CampaignTaskType.IG_REEL:
      return 'Instagram Reel';
    case CampaignTaskType.IG_STORY:
      return 'Instagram Story';
    case CampaignTaskType.TT_VIDEO:
      return 'TikTok Video';
    case CampaignTaskType.TW_TWEET:
      return 'X Tweet';
    case CampaignTaskType.TW_VIDEO:
      return 'X Video';
    case CampaignTaskType.TW_LIVE:
      return 'X Live';
    case CampaignTaskType.FB_SHARE:
      return 'Facebook Share';
    case CampaignTaskType.IG_SHARE:
      return 'Instagram Share';
    case CampaignTaskType.TT_SHARE:
      return 'TikTok Share';
    case CampaignTaskType.TW_SHARE:
      return 'X Share';
    case CampaignTaskType.YT_SHARE:
      return 'YouTube Share';
    case CampaignTaskType.LIVE_APPEARANCE:
      return 'Live Appearance';
    case CampaignTaskType.RECORDED_APPEARANCE:
      return 'Recorded Appearance';
    case CampaignTaskType.CONTENT: {
      const name = 'Content';
      if (task.__typename === 'CampaignContentTask' && task.mediaType) {
        return getMediaTypeText(task.mediaType) + ` ${name}`;
      }
      return 'Content';
    }
    default:
      return 'Unknown';
  }
};

export const getContentTypeText = (
  contentType:
    | GetCampaignOffers_getCampaignOffers_entities_deliverables_items
    | GetCampaignOffers_getCampaignOffers_entities_deliverables_items_CBDeliverableCopy_task
    | GetCampaignOffers_getCampaignOffers_entities_deliverables_items_CBDeliverableFileItem_task
    | GetCampaignOffers_getCampaignOffers_entities_deliverablesV2_items_CbDeliverableFilesItemV2
    | null
): string => {
  if (!contentType) return '';

  switch (contentType.type) {
    case CampaignTaskType.IG_LIVE:
      return 'Instagram Live';
    case CampaignTaskType.IG_POST:
      return 'Instagram Post';
    case CampaignTaskType.IG_REEL:
      return 'Instagram Reel';
    case CampaignTaskType.IG_STORY:
      return 'Instagram Story';
    case CampaignTaskType.TT_VIDEO:
      return 'TikTok Video';
    case CampaignTaskType.TW_TWEET:
      return 'X Tweet';
    case CampaignTaskType.TW_VIDEO:
      return 'X Video';
    case CampaignTaskType.TW_LIVE:
      return 'X Live';
    case CampaignTaskType.CONTENT: {
      const name = 'Content';
      if (
        contentType.__typename === 'CampaignContentTask' &&
        (contentType as { mediaType?: CampaignMediaType | null }).mediaType
      ) {
        return (
          getMediaTypeText(
            (contentType as { mediaType?: CampaignMediaType | null })
              .mediaType ?? undefined
          ) + ` ${name}`
        );
      }
      return 'Content';
    }
    case CampaignTaskType.FINAL_CONTENT:
      return 'Final Content';
    default:
      return 'Unknown';
  }
};
